import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {useFileViewerStore} from '../file-viewer-store'
import IconClose from '../icons/icon-close.svg'
import IconLeft from '../icons/icon-left.svg'
import IconRight from '../icons/icon-right.svg'

const TwIconClose = tw.div`
  absolute
  cursor-pointer
  right-8
  top-8
  text-obscure-constant-old
`

export const Close = observer(() => {
  const [state] = useFileViewerStore()
  const close = () => {
    state.onClose()
  }
  return (
    <TwIconClose onClick={close}>
      <IconClose />
    </TwIconClose>
  )
})

const TwIconLeft = tw.div`
  absolute
  transform
  -translate-y-1/2
  left-18
  top-1/2
`

const TwIconWrapper = tw.div`
  w-24
  h-24
  cursor-pointer
  rounded-4
  group-hover:bg-project-hover-old-dark
  group-active:bg-main-old-dark
  active:bg-main-old-dark
  select-none
`

const TwIcon = tw.div`
  flex
  items-center
  justify-center
  h-full
`

export const Prev = observer(() => {
  const [, store] = useFileViewerStore()
  const prev = () => {
    store.prev()
  }
  const render = () => {
    return (
      <div
        className="absolute cursor-pointer group"
        style={{top: 72, left: 0, width: 52, bottom: 88}}
        onClick={prev}
      >
        <TwIconLeft>
          <TwIconWrapper>
            <TwIcon>
              <IconLeft className="text-third-old-dark" />
            </TwIcon>
          </TwIconWrapper>
        </TwIconLeft>
      </div>
    )
  }
  return store.canGoPrev ? render() : null
})

const TwIconRight = tw.div`
  absolute
  transform
  -translate-y-1/2
  right-18
  top-1/2
`

const styleNext = {top: 72, right: 0, width: 52, bottom: 88}

export const Next = observer(() => {
  const [, store] = useFileViewerStore()
  const next = () => {
    store.next()
  }
  const render = () => {
    return (
      <div
        className="absolute cursor-pointer group"
        style={styleNext}
        onClick={next}
      >
        <TwIconRight>
          <TwIconWrapper>
            <TwIcon>
              <IconRight className="text-third-old-dark" />
            </TwIcon>
          </TwIconWrapper>
        </TwIconRight>
      </div>
    )
  }
  return store.canGoNext ? render() : null
})
